module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0010.jpg?v=b4f3987f";